import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyDriedApricotIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./DriedApricotIcon-e77a9e01.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyDriedApricotIcon as P };
